import api from './api';

const orderService = {
  // Same endpoint + payload shape the mobile app submits (OrderCreationScreen), so a record
  // created on web is indistinguishable from one created on mobile.
  createOrder: (data) => api.post('/orders', data),
  // Searches can include legacy patient names; keep them in the private request body.
  getOrders: (params) => api.post('/orders/search', params),
  getOrderById: (id) => api.get(`/orders/${id}`),
  getStatusCounts: (params = {}) => api.post('/orders/status-counts', params),
  updateOrder: (id, data) => api.put(`/admin/orders/${id}`, data),
  assignSalesRep: (id, salesRepId) => api.put(`/admin/orders/${id}/assign`, { salesRepId }),
  updateTracking: (id, trackingNumber) =>
    api.put(`/admin/orders/${id}/tracking`, { trackingNumber }),
  // Removes the order from the app; it can be restored. `force` is needed only when the order has
  // a QuickBooks invoice, which deleting here does NOT remove - the server refuses without it.
  deleteOrder: (id, force = false) =>
    api.delete(`/admin/orders/${id}`, { params: force ? { force: 'true' } : {} }),
  restoreOrder: (id) => api.post(`/admin/orders/${id}/restore`),
};

export default orderService;
